export const subscriptionConstants = {
  // Get Subscription Plan
  getSubscriptionPlanRequest: "GET_SUBSCRIPTION_PLAN_REQUEST",
  getSubscriptionPlanSuccess: "GET_SUBSCRIPTION_PLAN_SUCCESS",
  getSubscriptionPlanFailure: "GET_SUBSCRIPTION_PLAN_FAILURE",

  // Create Subscription
  createSubscriptionRequest: "CREATE_SUBSCRIPTION_REQUEST",
  createSubscriptionSuccess: "CREATE_SUBSCRIPTION_SUCCESS",
  createSubscriptionFailure: "CREATE_SUBSCRIPTION_FAILURE",

  // Get Subscription Status
  getSubscriptionStatusRequest: "GET_SUBSCRIPTION_STATUS_REQUEST",
  getSubscriptionStatusSuccess: "GET_SUBSCRIPTION_STATUS_SUCCESS",
  getSubscriptionStatusFailure: "GET_SUBSCRIPTION_STATUS_FAILURE",

  // Get Order Status
  getOrderStatusRequest: "GET_ORDER_STATUS_REQUEST",
  getOrderStatusSuccess: "GET_ORDER_STATUS_SUCCESS",
  getOrderStatusFailure: "GET_ORDER_STATUS_FAILURE",

  // Sync Plans
  syncPlansRequest: "SYNC_PLANS_REQUEST",
  syncPlansSuccess: "SYNC_PLANS_SUCCESS",
  syncPlansFailure: "SYNC_PLANS_FAILURE",

  // Get All Plans
  getAllPlansRequest: "GET_ALL_PLANS_REQUEST",
  getAllPlansSuccess: "GET_ALL_PLANS_SUCCESS",
  getAllPlansFailure: "GET_ALL_PLANS_FAILURE",

  // Get User Subscription Status
  getUserSubscriptionStatusRequest: "GET_USER_SUBSCRIPTION_STATUS_REQUEST",
  getUserSubscriptionStatusSuccess: "GET_USER_SUBSCRIPTION_STATUS_SUCCESS",
  getUserSubscriptionStatusFailure: "GET_USER_SUBSCRIPTION_STATUS_FAILURE",

  // Super Admin: List Plans
  listAdminPlansRequest: "LIST_ADMIN_PLANS_REQUEST",
  listAdminPlansSuccess: "LIST_ADMIN_PLANS_SUCCESS",
  listAdminPlansFailure: "LIST_ADMIN_PLANS_FAILURE",

  // Super Admin: View Plan
  viewAdminPlanRequest: "VIEW_ADMIN_PLAN_REQUEST",
  viewAdminPlanSuccess: "VIEW_ADMIN_PLAN_SUCCESS",
  viewAdminPlanFailure: "VIEW_ADMIN_PLAN_FAILURE",

  // Super Admin: Save Plan (create + update)
  saveAdminPlanRequest: "SAVE_ADMIN_PLAN_REQUEST",
  saveAdminPlanSuccess: "SAVE_ADMIN_PLAN_SUCCESS",
  saveAdminPlanFailure: "SAVE_ADMIN_PLAN_FAILURE",

  // Super Admin: Delete Plan
  deleteAdminPlanRequest: "DELETE_ADMIN_PLAN_REQUEST",
  deleteAdminPlanSuccess: "DELETE_ADMIN_PLAN_SUCCESS",
  deleteAdminPlanFailure: "DELETE_ADMIN_PLAN_FAILURE",

  // Get App Routes (feeds plan form route dropdown)
  getRoutesRequest: "GET_ROUTES_REQUEST",
  getRoutesSuccess: "GET_ROUTES_SUCCESS",
  getRoutesFailure: "GET_ROUTES_FAILURE",

  getSubscriptionSyncStatusRequest : "GET_SUBSCRIPTION_SYNC_STATUS_REQUEST",
  getSubscriptionSyncStatusSuccess : "GET_SUBSCRIPTION_SYNC_STATUS_SUCCESS",
  getSubscriptionSyncStatusFailure : "GET_SUBSCRIPTION_SYNC_STATUS_FAILURE",

  getInvoiceRequest: "GET_INVOICE_REQUEST", 
  getInvoiceSuccess: "GET_INVOICE_SUCCESS",
  getInvoiceFailure: "GET_INVOICE_FAILURE",

  getAllInvoicesRequest: "GET_ALL_INVOICES_REQUEST",
  getAllInvoicesSuccess: "GET_ALL_INVOICES_SUCCESS",
  getAllInvoicesFailure: "GET_ALL_INVOICES_FAILURE",

  getInvoicePDFRequest: "GET_INVOICE_PDF_REQUEST",
  getInvoicePDFSuccess: "GET_INVOICE_PDF_SUCCESS",
  getInvoicePDFFailure: "GET_INVOICE_PDF_FAILURE",

  getOverallInvoicesRequest: "GET_OVERALL_INVOICES_REQUEST",
  getOverallInvoicesSuccess: "GET_OVERALL_INVOICES_SUCCESS",
  getOverallInvoicesFailure: "GET_OVERALL_INVOICES_FAILURE",

};



// App routes a plan can unlock (drives plan.route[] used for menu gating).
// Fallback only — the plan form loads the live list from GET /api/v1/routes.
export const APP_ROUTE_OPTIONS = [
  { label: "Dashboard", value: "/dashboard" },
  { label: "Users", value: "/users" },
  { label: "Enrollment", value: "/enrollments" },
  { label: "Services", value: "/services" },
  { label: "Category", value: "/categories" },
  { label: "Batches", value: "/batches" },
  { label: "Vehicles", value: "/vehicles" },
  { label: "Accounting", value: "/expenses" },
  { label: "Leads", value: "/leads" },
  { label: "Queries", value: "/queries" },
  { label: "Settings", value: "/settings" },
  { label: "Profile", value: "/profile" },
];

export const subscription_plan = {
  free: "Free Trial",
  standard: "Standard",
  pro: "Professional",
  ultimate: "Enterprise"
};

// Free Trial Constants
export const FREE_TRIAL_DAYS = 7;
export const FREE_TRIAL_EXPIRED_MESSAGE = "Your free trial has expired. Please upgrade to continue using the service.";
export const FREE_TRIAL_EXPIRING_SOON_MESSAGE = "Your free trial is expiring soon. Upgrade now to avoid service interruption.";
export const SUBSCRIPTION_EXPIRED_MESSAGE = "Your subscription has expired. Please renew to continue.";
